/**
 * Seeded PRNG shared by everything that generates a board.
 *
 * Extracted in WP-35.23 from the retired single-axis `level-generator.ts`, which
 * was the only reason two live modules still imported that file. Deterministic
 * generation is the whole contract — every level is a pure function of its
 * number — so this is load-bearing, not a utility.
 */
export function mulberry32(seed) {
    let s = seed;
    return function () {
        s = (s + 0x6d2b79f5) | 0;
        let t = Math.imul(s ^ (s >>> 15), 1 | s);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}
